/**
 * Framework resolvers — schema-aware functions that the framework base
 * classes need at runtime but cannot import statically (they live in
 * `@sourcepilot/generated`, which depends on framework — importing back
 * would re-create the cycle this package boundary exists to break).
 *
 * `@sourcepilot/generated` installs the concrete resolvers at module load
 * (see model-registry's bottom-of-file install block). Framework base
 * classes consume them via `getFrameworkResolvers()`.
 */

export type ObjectMode = 'new_only' | 'existing_only' | 'both';

export interface ConstructionSpec {
  max_count?: number;
  object_mode?: ObjectMode;
  [relationshipField: string]: ConstructionSpec | number | string | undefined;
}

export interface FrameworkResolvers {
  getRelationshipPropertyName: (relType: string, reverse?: boolean) => string | undefined;
  getRelationshipClass: (relType: string) => any | undefined;
  modelRegistry: Record<string, any>;
  isRelationshipAllowed: (spec: ConstructionSpec | undefined, fieldName: string) => boolean;
  getNestedSpec: (spec: ConstructionSpec | undefined, fieldName: string) => ConstructionSpec | undefined;
  getModifyConstructionSpec: (modelName: string) => ConstructionSpec | undefined;
}

const defaults: FrameworkResolvers = {
  getRelationshipPropertyName: () => undefined,
  getRelationshipClass: () => undefined,
  modelRegistry: {},
  isRelationshipAllowed: () => true,
  getNestedSpec: () => undefined,
  getModifyConstructionSpec: () => undefined,
};

let _resolvers: FrameworkResolvers = defaults;

export function setFrameworkResolvers(resolvers: Partial<FrameworkResolvers>): void {
  _resolvers = { ..._resolvers, ...resolvers };
}

export function getFrameworkResolvers(): FrameworkResolvers {
  return _resolvers;
}
